import { createFileRoute } from '@tanstack/react-router'
import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'
import { CalendarHeader } from "@/components/calendar/calendar-header"
import { CalendarMain } from "@/components/calendar/calendar-main"
import { EventModal } from "@/components/calendar/event-modal"
import { CalendarProvider } from "@/components/calendar/calendar-context"
import { CalendarSyncWarningAlert } from "@/components/calendar/calendar-sync-warning-alert"
import { Card } from "@/components/ui/card"
import { getDateRangeForView } from "@/lib/calendar-utils"
import { canPreloadOrganizationQueries, preloadQueries } from "@/lib/route-preloading"
import { listEventsQueryOptions } from "@/stores/events.store"
import { listInquiriesQueryOptions } from "@/stores/leads.store"
import { organizationStore } from "@/stores/organization.store"
import { listTasksQueryOptions } from "@/stores/tasks.store"
import { TaskStatusEnum } from "@/gen/cortado/v1/settings_pb"

export const Route = createFileRoute('/_app/_home/calendar')({
  component: CalendarPage,
  loader: ({ context }) => {
    if (!canPreloadOrganizationQueries(context.auth)) return
    const organizationId = organizationStore.state.selectedOrganizationId
    if (!organizationId) return

    const dateRange = getDateRangeForView(new Date(), 'month')
    preloadQueries(context.queryClient, [
      listInquiriesQueryOptions({
        organizationId,
        eventDateStart: dateRange.start,
        eventDateEnd: dateRange.end,
      }),
      listEventsQueryOptions({
        organizationId,
        eventDateStart: dateRange.start,
        eventDateEnd: dateRange.end,
      }),
      listTasksQueryOptions({
        organizationId,
        dueDateStart: dateRange.start,
        dueDateEnd: dateRange.end,
        statuses: [
          TaskStatusEnum.TASK_STATUS_NOT_STARTED,
          TaskStatusEnum.TASK_STATUS_IN_PROGRESS,
          TaskStatusEnum.TASK_STATUS_COMPLETED,
        ],
      }),
    ])
  },
})

function CalendarPage() {
  useBreadcrumbFromRoute()

  return (
    <CalendarProvider>
      <div className="flex h-full flex-col p-4">
        <CalendarSyncWarningAlert />
        <Card className="flex-1 flex flex-col overflow-hidden gap-0 pt-0">
          <CalendarHeader />
          <CalendarMain />
        </Card>
        <EventModal />
      </div>
    </CalendarProvider>
  )
}
